<template>
    <Paper class="single">
            <div class="single-list-detail">
                <el-row>
                    <el-col :span="8">
                        <span>服务平台 :</span> <span>{{ info.siteName }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>车次号 :</span><span>{{ info.trainNum }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>状态 :</span><span>{{ statusName }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>订单数 :</span><span>{{ info.orderNum }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>方数(m³) :</span><span>{{ info.volume }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>总里程(km) :</span><span>{{ info.mileage }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>串点数 :</span><span>{{ info.pointNum }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>推荐车型(米) :</span><span>{{ info.truckModel }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>车辆信息 :</span><span>{{ info.equipmentName }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>司机信息 :</span><span>{{ info.driver }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>车牌号 :</span><span>{{ info.vehicleCard }}</span>
                    </el-col>
                    <el-col :span="8">
                        <span>发车单号 :</span><span>{{ info.dispatchNo }}</span>
                    </el-col>
                </el-row>
            </div>
            <detail-table
                :columnLists="config.columns"
                :tableData="tableData"
            >
            </detail-table>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import DetailTable from '../component/DetailTable';
import config from './config';
import * as api from '../../../../api/trainList';
import { PromiseUtils } from '../utils/promise';
import { TrainStatusNameTranslator, TaskStatusName } from '../utils/train';

export default {
    name: 'train-list-detail',
    components: { Paper, DetailTable },
    data() {
        return {
            config,
            statusName: '',
            info: {},
            tableData: []
        };
    },
    created() {
        this.messenger = PromiseUtils.buildErrorMessenger(this.$message);
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 获取数据
        getData() {
            const trainNum = this.$route.query.trainNum;
            // this.info = JSON.parse(this.$route.query.row);
            return api.lineDetailWithOrder({ trainNumList: [trainNum] })
                .then(async (res) => {
                    PromiseUtils.assertResponseSuccessWithData(res);
                    PromiseUtils.assert(res.data.list && res.data.list.length > 0, '获取车次详情失败');
                    this.info = res.data.list[0];
                    this.tableData = await this.formatResponseTableData(this.info, this.info.lineOrderResponseList || []);

                    // 转换状态名称
                    const t = await TrainStatusNameTranslator.create();
                    this.statusName = t.toName(this.info.dispatchStatus, this.info.dispatchStatus);
                })
                .catch(err => {
                    this.messenger.w(err);
                });
        },
        async  formatResponseTableData(info, list) {
            const t = await TaskStatusName.create();
            return list.map(row => {
                row.restrictFlagName = ['否', '是'][row.restrictFlag] || '';
                row.taskStatusName = t.toName(row.taskStatus, row.taskStatus);
                return row;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.single {
    height: calc(100vh - 60px);
    overflow-y: scroll;
}

.single-list-detail {
    margin-bottom: 20px;
     .el-row {
            border: 1px solid #dcdfe6;
            border-right: none;
            border-bottom: none;
            background-color: #f5f7fa;
            .el-col {
                display: flex;
                justify-content: space-around;
                height: 44px;
                border-bottom: 1px solid #dcdfe6;
                border-right: 1px solid #dcdfe6;
                line-height: 44px;
                margin-bottom: 0;
                padding-left: 12px;

                span:first-child {
                    flex: 4;
                    border-right: 1px solid #dcdfe6;
                }
                span:last-child {
                    flex: 5;
                    display: inline-block;
                    height: 100%;
                    background-color: #fff;
                    padding-left: 12px;
                }
            }
    }
}
</style>
